module.exports = __webpack_public_path__ + "static/img/1uav3.f2bb5a29.png";